import { formatBytes } from '../../../utilities/format';

interface Props {
  type: string | undefined | null;
  bytes: number;
  files: number;
}

// Renders a `<td>` for a Collection's source/output: type chip, formatted size, file count.
export function IoCell({ type, bytes, files }: Props) {
  return (
    <td>
      <span className="label label-default">{type || 'n/a'}</span>
      {' '}{formatBytes(bytes)} — {files.toLocaleString()} Files
    </td>
  );
}
